module.exports = __webpack_public_path__ + "img/port-everglades-emergency-power-study-3.8424b2ef.jpg";